$(function(){
    if ( $('.app-banner').length )
    {
        const isClosed = EUCUtils.readCookie('mojeEUC-app-banner');

        if ( !isClosed )
        {
            if ( isIOS() ){
                // change mobile link if IOS
                let $mobileLink = $('.app-banner').find('[data-app-banner-ios-url]');
                let iosUrl = $mobileLink.data('app-banner-ios-url');

                $mobileLink.attr('href', iosUrl);
            }

            // show banner if not shown
            $('.app-banner').show();
        }

        // hide banner on click
        $('.app-banner').on('click', '[data-app-banner-close]', function(){
            EUCUtils.createCookie('mojeEUC-app-banner', 'closed', 30);
            $('.app-banner').hide();
        });
    }
});

// detect ios
function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}